/* eslint-disable import/extensions */
/* eslint react/no-danger: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import DOMPurify from 'dompurify';

const MarkdownText = ({ content, children }) => {
  marked.setOptions({
    breaks: true,
    headerPrefix: 'mhub-content-',
  });

  const sanitizedHTML = DOMPurify.sanitize(marked.parse(children || content));

  return (
    <div
      className="markdown-text"
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  );
};

MarkdownText.propTypes = {
  content: PropTypes.string,
  children: PropTypes.string,
};

export default MarkdownText;



// WEBPACK FOOTER //
// ./src/components/MarkdownText.jsx